import { useSettings, resolveTimeZone, zoneAbbreviation, formatDateTime } from "@helm/core";

/**
 * The resolved display zone (IANA id) from the synced `display_time_zone` setting. Every time the
 * UI shows goes through this and the formatters in packages/core/src/time/zone.ts.
 */
export function useDisplayZone(): string {
  const setting = useSettings((s) => s.settings.display_time_zone);
  return resolveTimeZone(setting);
}

/** "Sun, Sep 27, 18:30 KST" */
export function formatInstantWithZone(ms: number, zone: string): string {
  return `${formatDateTime(ms, zone)} ${zoneAbbreviation(zone, ms)}`;
}
